import { render, staticRenderFns } from "./bookingAirUldDataGrid.vue?vue&type=template&id=4b0c71ba&"
import script from "./bookingAirUldDataGrid.vue?vue&type=script&lang=js&"
export * from "./bookingAirUldDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./bookingAirUldDataGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0c71ba')) {
      api.createRecord('4b0c71ba', component.options)
    } else {
      api.reload('4b0c71ba', component.options)
    }
    module.hot.accept("./bookingAirUldDataGrid.vue?vue&type=template&id=4b0c71ba&", function () {
      api.rerender('4b0c71ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/components/bookingAirUldDataGrid.vue"
export default component.exports